<template lang="pug">
  div.tendency-quota
    module-title(title="指标")
    div.quotas
      div.quota(v-for="(q, i) in quotas" :key="i")
        p.name {{q.name}}
        label.value {{q.value}}
        span.compare {{q.compare}}
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
export default {
  name: 'TendencyQuota',
  components: {
    ModuleTitle
  },
  props: {
    quotas: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .tendency-quota{
    flex: 9;
    margin-right: 20px;
    height: 160px;
    background-color: #ffffff;
    border-radius: 4px;
    padding: 14px;
    .quotas{
      height: calc(100% - 21px);
      display: flex;
      align-items: center;
      .quota{
        padding: 10px 20px;
        flex: 1;
        height: 80px;
        border-right: 2px solid #f4f6fa;
        &:last-child{
          border-right: none;
        }
        p.name{
          color: #666;
          margin-bottom: 16px;
        }
        label.value{
          font-size: 22px;
          color: #3989cb;
          margin-right: 16px;
        }
        span.compare{
          color: #999;
          font-size: 12px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventTendency/TendencyQuota.vue